var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineAngleDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 67,
    viewBox: "0 0 123 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.68 1.95002C8.94999 -0.699977 4.59999 -0.639977 1.94999 2.08002C-0.700009 4.80002 -0.640009 9.16002 2.07999 11.81L56.87 64.94L61.67 60.01L56.87 64.96C59.61 67.61 63.97 67.54 66.62 64.81C66.7 64.73 66.77 64.65 66.84 64.57L120.79 11.81C123.52 9.16002 123.58 4.80002 120.93 2.08002C118.28 -0.639977 113.92 -0.709977 111.2 1.95002L61.65 50.41L11.68 1.95002Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.88,
    height: 66.91,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAngleDownIcon);
export default __webpack_public_path__ + "static/media/line-angle-down-icon.a9f1910584a6f5f812bfd60fd7387198.svg";
export { ForwardRef as ReactComponent };